import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  AppBar, Box, Toolbar, TextField, useTheme, IconButton, Button, Menu,
  MenuItem, CssBaseline, Modal,
  Paper, Typography,Tooltip,
} from "@mui/material";
import { useState, useEffect } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import PrintIcon from '@mui/icons-material/Print'; 

// NOTE: Placeholder components/paths, assuming they exist in your project
import { tokens } from "../../../theme/theme"; 
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import AddNewPriceList from "./AddNewPriceList"; 
import AddGsmRange from "./AddGSMRange"; 
import ModuleHelpDialog from "../../../components/ModuleHelpDialog";
import { ordermanagementhelp } from "../../../data/ordermanagementhelp";
import HelpIcon from '@mui/icons-material/HelpOutline';

const PriceListMaster = ({ handleBackWinderMachineEntry }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // UI State
  const [anchorElFirst, setAnchorElFirst] = useState(null);
  const openFirst = Boolean(anchorElFirst);
  const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Price Lists');
  const [selectedStatus, setSelectedStatus] = useState('All');

  const [newStore, setNewStore] = useState(false);
  const [storeHome, setStoreHome] = useState(true);
  const [showAddGsmRange, setShowAddGsmRange] = useState(false);

  // State to hold the ID of the price list currently being edited/viewed for GSM ranges
  const [selectedPriceListId, setSelectedPriceListId] = useState(null); 
  // State to hold the Name of the price list currently being edited/viewed
  const [selectedPriceListName, setSelectedPriceListName] = useState(''); 
  
  const [editStoreID, setEditStoreID] = useState(0);

  // Data State
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    code: '',
  name: '',
  fystartdate: '',
  effective_start_date: '',
  effective_end_date: '',
  dealer_names: '',
  state_zone: '',
  status: '',
  });

  // Modal State for Filters
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const handleOpenFilterModal = () => setOpenFilterModal(true);
  const handleCloseFilterModal = () => setOpenFilterModal(false);

  // New State for Print Report Modal
  const [openPrintModal, setOpenPrintModal] = useState(false);
  const [printHtmlContent, setPrintHtmlContent] = useState('');

//help menu
const [helpOpen, setHelpOpen] = useState(false);
    const handleCloseHelp = () => setHelpOpen(false);
    const handleHelpMenuClick = () => setHelpOpen(true);

  const handleOpenPrintModal = () => setOpenPrintModal(true);
  const handleClosePrintModal = () => {
    setOpenPrintModal(false);
    setPrintHtmlContent('');
  };

  // const handleFilterChange = (event) => {
  //   const { name, value } = event.target;
  //   setFilters((prev) => ({ ...prev, [name]: value }));
  // };
const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  /**
   * Formats date to dd-Mon-yyyy (e.g., 10-Mar-2025)
   */
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    if (isNaN(date)) return dateStr; 
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).replace(/ /g, "-"); 
  };
  
  /**
   * Formats date to dd/MM/yyyy (e.g., 10/03/2025)
   */
  const formatDateSlash = (dateStr) => {
      if (!dateStr) return "-";
      const date = new Date(dateStr);
      if (isNaN(date)) return dateStr; 
      
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`; 
  };

  const handleMenuClickFirst = (event) => setAnchorElFirst(event.currentTarget);
  const handleMenuCloseFirst = () => setAnchorElFirst(null);
  const handleMenuItemClickFirst = (option) => {
    setSelectedOptionFirst(option);
    if (option === 'All Price Lists') setSelectedStatus('All');
    else if (option === 'Active Price Lists') setSelectedStatus('Active'); 
    else if (option === 'In Active Price Lists') setSelectedStatus('Inactive'); 
    setAnchorElFirst(null);
  };

  const handleShowNewVendor = () => {
    setEditStoreID(0);
    setNewStore(true);
    setStoreHome(false);
    setShowAddGsmRange(false);
  };

  const handleCallEdit = (row) => {
    setSelectedPriceListId(row.pricelistid);
    setSelectedPriceListName(row.name);
    setStoreHome(false);
    setNewStore(false);
    setShowAddGsmRange(true);
  };

  const handlecallback = () => {
    setStoreHome(true);
    setNewStore(false);
    setShowAddGsmRange(false);
    loadStoreList();
  };

  useEffect(() => {
    if (!isDataLoaded) {
      loadStoreList();
    }
  }, [isDataLoaded]);

  const loadStoreList = async () => {
    let company_id = localStorage.getItem('companyid') || 1;
    const para = { p_companyid: company_id, p_plantid: 1 };
    try {
      const result = await callApi(API_ENDPOINTS.SALES_GET_PRICELIST, 'POST', { 'Content-Type': 'application/json' }, para);
      if (result && result.length > 0) {
        setData(result);
        setIsDataLoaded(true);
      }
    } catch (error) {
      alert(error.message);
    }
  };

  const filteredData = data.filter((row) => {
  return Object.keys(filters).every((key) => {
    if (!filters[key]) return true;

    // Convert dates to DD/MM/YYYY for filtering
    const rowValue =
      key.includes("date")
        ? formatDate(row[key]) // convert to dd-Mon-yyyy
        : String(row[key] || '');

    return rowValue.toLowerCase().includes(filters[key].toLowerCase());
  });
});

  const handlePrint = async (priceListId) => {
    try {
      const PrintData = {
        SCompanyID: localStorage.getItem("companyid") || 1,
        SFinYearID: 1,
        PriceIdList: priceListId
      };

      const response = await callApi(
        API_ENDPOINTS.SALES_PRINT_PRICELIST,
        "POST",
        { "Content-Type": "application/json" },
        PrintData
      );

      // --- CRITICAL FIX: Check for the array structure and access index [0] ---
      if (!response || !response.Header || !response.Header[0]) {
        alert("No Data to Print for this Price List.");
        return;
      }

      // FIX 1: Get the actual header object from index 0 of the Header array
      const headerData = response.Header[0];
      const items = response.Details || [];
      const todayDateFormatted = formatDate(new Date());

      // 🔹 Extract header info using headerData
      const companyName = headerData.ICompanyName || "N/A"; 
      const companyAddress = [
        headerData.ICompanyAddrLine1,
        headerData.ICompanyAddrLine2,
        headerData.ICompanyAddrLine3,
        headerData.ICompanyAddrLine4,
        `${headerData.ICompanyAddrState || ""} - ${headerData.ICompanyAddrPincode || ""}`,
        headerData.ICompanyAddrCountry
      ]
        .filter(Boolean)
        .join(", "); 

      const gstNumber = headerData.ICompanyGSTNo ? `GSTIN: ${headerData.ICompanyGSTNo}` : ""; 
      const priceListName = headerData.PriceListName || 'Price List Report'; 
      
      // 🌟 NEW: Calculate both date formats
      const effectiveDateMon = formatDate(headerData.EffectiveStartDate); // e.g., 10-Mar-2025 (dd-Mon-yyyy)
      const effectiveDateSlash = formatDateSlash(headerData.EffectiveStartDate); // e.g., 10/03/2025 (dd/MM/yyyy)
      
      // FIX 2: Change split separator to comma (',') for dealer/state data
      const applicableDealers = (headerData.ApplicableDealers || "").split(',').filter(d => d.trim() !== "");
      const applicableStates = (headerData.ApplicableStates || "").split(',').filter(s => s.trim() !== "");
      
      // Combine dealers and states into rows for the two-column layout
      const maxRows = Math.max(applicableDealers.length, applicableStates.length);
      const dealerStateRows = Array.from({ length: maxRows }).map((_, index) => {
        const dealer = applicableDealers[index] || "";
        const state = applicableStates[index] || "";
        return `
          <tr>
            <td>${dealer}</td>
            <td>${state}</td>
          </tr>
        `;
      }).join('');

      // --- Grouping Logic for Main Table (Mimics PDF Rowspan) ---
      const groupedData = [];
      if (items.length > 0) {
        let currentGroup = { Variety: items[0].Variety, rows: [] };
        for (const row of items) {
          if (row.Variety !== currentGroup.Variety) {
            groupedData.push(currentGroup);
            currentGroup = { Variety: row.Variety, rows: [] };
          }
          currentGroup.rows.push(row);
        }
        groupedData.push(currentGroup);
      }

      let serialNo = 1;
      const tableBodyContent = groupedData.map(group => {
        const rowCount = group.rows.length;
        return group.rows.map((row, index) => {
          const isFirstRow = index === 0;
          
          return `
            <tr>
              ${isFirstRow ? `<td rowspan="${rowCount}" style="width: 5%;">${serialNo++}</td>` : ''}
              ${isFirstRow ? `<td rowspan="${rowCount}" style="width: 15%;">${row.Variety}</td>` : ''}
              <td style="width: 15%;">${row.GSMStart || '-'}</td>
              <td style="width: 15%;">${row.GSMEnd || '-'}</td>
              <td style="width: 15%;">${row.GSMRange || '-'}</td>
              <td style="width: 15%;">${row.ReelPrice || '-'}</td>
              <td style="width: 15%;">${row.SheetPrice || '-'}</td>
            </tr>
          `;
        }).join('');
      }).join('');
      // -----------------------------------------------------------
      
      const now = new Date();
const todayDateTime = now.toLocaleString("en-GB", { 
  day: "2-digit", month: "2-digit", year: "numeric", 
  hour: "2-digit", minute: "2-digit", second: "2-digit", 
  hour12: true 
}).replace(",", "");

const html = `
<html>
  <head>
    <title>Price List GSM Breakdown Report</title>
    <style>
      @page { size: A4; margin: 12mm; }
      body { font-family: Arial, sans-serif; font-size: 10pt; margin: 0; padding: 0; }
      
      /* --- Header --- */
      .header { width: 100%; margin-bottom: 5px; }
      .header-left { font-size: 9pt; text-align: left; }
      .header-left div { margin: 2px 0; }
      .company-name { text-align: center; font-weight: bold; font-size: 12pt; margin-top: -35px; }

      /* --- Title --- */
      .title { text-align: center; font-weight: bold; font-size: 11pt; margin: 15px 0; }

      /* --- Party Table --- */
      .meta-table { width: 100%; border-collapse: collapse; margin-bottom: 15px; }
      .meta-table th, .meta-table td { border: 1px solid black; padding: 4px; font-size: 9pt; }
      .meta-table th { background: #f2f2f2; text-align: center; }

      /* --- Main Breakdown Table --- */
      .data-table { width: 100%; border-collapse: collapse; }
      .data-table th, .data-table td { border: 1px solid black; padding: 5px; text-align: center; font-size: 9pt; }
      .data-table th { background: #f2f2f2; }

      /* --- Footer --- */
      .note { margin-top: 10px; font-style: italic; font-size: 9pt; }
      .footer { margin-top: 30px; display: flex; justify-content: space-between; font-size: 9pt; }
      .page-footer { text-align: right; font-size: 9pt; margin-top: 5px; }
    </style>
  </head>
  <body>
    <div class="header">
      <div class="header-left">
        <div>${companyAddress}</div>
        <div>${gstNumber}</div>
      </div>
      <div class="company-name">${companyName}</div>
    </div>

    <div class="title">
      ${priceListName} (PLUS MINUS 5 % ${effectiveDateSlash}) WITH EFFECT FROM ${effectiveDateMon}
    </div>

    <table class="meta-table">
      <thead>
        <tr><th>Party Name</th><th>Party Location</th></tr>
      </thead>
      <tbody>
        ${dealerStateRows}
      </tbody>
    </table>

    <table class="data-table">
      <thead>
        <tr>
          <th style="width: 5%;">S. No</th>
          <th style="width: 15%;">GSM</th>
          <th style="width: 20%;">Ex-Mill Price / Kg (Reel)</th>
          <th style="width: 20%;">Ex-Mill Price / Kg (Sheet)</th>
          <th style="width: 20%;">Product Name</th>
        </tr>
      </thead>
      <tbody>
        ${items.map((row, i) => `
          <tr>
            <td>${i + 1}</td>
            <td>${row.GSMStart}-${row.GSMEnd}</td>
            <td>${row.ReelPrice || '-'}</td>
            <td>${row.SheetPrice || '-'}</td>
            <td>${row.Variety || '-'}</td>
          </tr>
        `).join('')}
      </tbody>
    </table>

    <div class="note">Note :</div>
    <div class="note">For ${companyName}</div>

    <div class="footer">
      <div>Printed on ${todayDateTime}</div>
      <div>Authorized Signatories</div>
    </div>
    <div class="page-footer">Page 1 of 1</div>
  </body>
</html>
`;

      setPrintHtmlContent(html);
      handleOpenPrintModal();

    } catch (err) {
      console.error("Print error:", err);
      alert("Error generating print report.");
    }
  };


  return (
    <Box>
      <CssBaseline />

      {/* --- Add GSM View --- */}
      {showAddGsmRange && (
        <AddGsmRange
          priceListId={selectedPriceListId}
          priceListName={selectedPriceListName}
          handlecallback={handlecallback}
        />
      )}

      {/* --- Add New View --- */}
      {newStore && (
        <AddNewPriceList handlecallback={handlecallback} editStoreID={editStoreID} />
      )}

      {/* --- Table View (storeHome) --- */}
      {storeHome && (
        <>
          <AppBar position="static" sx={{ backgroundColor: "inherit", height: "48px", justifyContent: "center" }}>
            <Toolbar>
              <Button
                color="secondary"
                onClick={handleMenuClickFirst}
                endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
              >
                {selectedOptionFirst}
              </Button>
              <Menu anchorEl={anchorElFirst} open={openFirst} onClose={handleMenuCloseFirst}>
                <MenuItem onClick={() => handleMenuItemClickFirst('All Price Lists')}>All Price Lists</MenuItem>
                <MenuItem onClick={() => handleMenuItemClickFirst('Active Price Lists')}>Active Price Lists</MenuItem>
                <MenuItem onClick={() => handleMenuItemClickFirst('In Active Price Lists')}>In Active Price Lists</MenuItem>
              </Menu>

              <Button
                size="small"
                variant="contained"
                onClick={handleShowNewVendor}
                color="secondary"
                startIcon={<AddIcon />}
                sx={{ marginLeft: 'auto' }}
              >
                New
              </Button>
              <Tooltip title="View help document details" arrow>
                              <IconButton
                                size="small"
                                aria-label="help"
                                sx={{ mx: 1 }}
                                onClick={handleHelpMenuClick}
                              >
                                <HelpIcon sx={{ fontSize: 18 }} />
                              </IconButton>
                            </Tooltip>
                            
                            
                                                    <ModuleHelpDialog
                                                        open={helpOpen}
                                                        onClose={handleCloseHelp}
                                                        data={ordermanagementhelp.PriceListManagementSystem}
                                                    />

              <IconButton onClick={handleBackWinderMachineEntry}>
                <Close fontSize="inherit" style={{ color: "#2196F3", fontSize: "18px" }} />
              </IconButton>
            </Toolbar>
          </AppBar>

          <Box padding={1}>
            <TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
              <Table size="small" sx={{ tableLayout: "auto", whiteSpace: "nowrap" }}>
                <TableHead>
  <TableRow>
    <TableCell>PriceList Code</TableCell>
    <TableCell>PriceList Name</TableCell>
    <TableCell>Financial Year</TableCell>
    <TableCell>Effective Start Date</TableCell>
    <TableCell>Effective End Date</TableCell>
    <TableCell>Applicable Dealers</TableCell>
    <TableCell>Applicable States</TableCell>
    <TableCell>Status</TableCell>
    <TableCell>Action</TableCell>
  </TableRow>
   {/* 🔍 Column Filter Row */}
                        <TableRow>
                          {Object.keys(filters).map((key) => (
                            <TableCell key={key}>
                              <TextField
                                variant="outlined"
                                size="small"
                                placeholder="Search..."
                                fullWidth
                                value={filters[key]}
                                onChange={(e) =>
                                  handleFilterChange(key, e.target.value)
                                }
                              />
                            </TableCell>
                          ))}
                        </TableRow>

  {/* --- FILTER ROW ---
 <TableRow
  sx={{
    "& th, & td": {
      padding: "2px 4px",
      fontSize: "13px",
      lineHeight: 1,
    },
  }}
>
    <TableCell>
      <TextField
        variant="outlined"
        fullWidth
        name="code"
        value={filters.code}
        onChange={handleFilterChange}
      />
    </TableCell>

    <TableCell>
      <TextField
        variant="outlined"
        fullWidth
        name="name"
        value={filters.name}
        onChange={handleFilterChange}
      />
    </TableCell>

    <TableCell>
      <TextField
        variant="outlined"
        fullWidth
        name="fystartdate"
        value={filters.fystartdate}
        onChange={handleFilterChange}
      />
    </TableCell>

    <TableCell>
      <TextField
        variant="outlined"
        fullWidth
        name="effective_start_date"
        value={filters.effective_start_date}
        onChange={handleFilterChange}
      />
    </TableCell>

    <TableCell>
      <TextField
        variant="outlined"
        fullWidth
        name="effective_end_date"
        value={filters.effective_end_date}
        onChange={handleFilterChange}
      />
    </TableCell>

    <TableCell>
      <TextField
        variant="outlined"
        fullWidth
        name="dealer_names"
        value={filters.dealer_names}
        onChange={handleFilterChange}
      />
    </TableCell>

    <TableCell>
      <TextField
        variant="outlined"
        fullWidth
        name="state_zone"
        value={filters.state_zone}
        onChange={handleFilterChange}
      />
    </TableCell>

    <TableCell>
      <TextField
        variant="outlined"
        fullWidth
        name="status"
        value={filters.status}
        onChange={handleFilterChange}
      />
    </TableCell>

    <TableCell />
  </TableRow> */}
</TableHead>

                <TableBody>
                  {filteredData.map((row) => (
                    <TableRow key={row.pricelistid}>
                      <TableCell>
                        <span
                          style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                          onClick={() => handleCallEdit(row)}
                        >
                          {row.code}
                        </span>
                      </TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{formatDate(row.fystartdate)}</TableCell>
                      <TableCell>{formatDate(row.effective_start_date)}</TableCell>
                      <TableCell>{formatDate(row.effective_end_date)}</TableCell>
                      <TableCell>{row.dealer_names}</TableCell>
                      <TableCell>{row.state_zone}</TableCell>
                      <TableCell>{row.status}</TableCell>
                      <TableCell>
                        <Button
                          size="small"
                          variant="outlined"
                          color="secondary"
                          startIcon={<PrintIcon />}
                          onClick={() => handlePrint(row.pricelistid)}
                          sx={{ minWidth: '80px' }}
                        >
                          Print
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      )}

      {/* 🚀 Print Report Modal (Dialog Content) 🚀 */}
      <Modal open={openPrintModal} onClose={handleClosePrintModal} aria-labelledby="print-report-title">
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%', 
          height: '90%', 
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 1,
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, borderBottom: '1px solid #ccc' }}>
            <Typography id="print-report-title" variant="h6" component="h2">
              Price List GSM Breakdown Report
            </Typography>
            <Box>
              <Button
                variant="contained"
                onClick={() => {
                  const iframe = document.getElementById('print-iframe');
                  if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.print();
                  }
                }}
                startIcon={<PrintIcon />}
                sx={{ mr: 1 }}
              >
                Print
              </Button>
              <IconButton onClick={handleClosePrintModal}>
                <Close />
              </IconButton>
            </Box>
          </Box>

          <Paper elevation={0} sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <iframe
              id="print-iframe"
              srcDoc={printHtmlContent}
              style={{ width: '100%', height: '100%', border: 'none' }}
              title="Price List Report"
            />
          </Paper>
        </Box>
      </Modal>
      {/* 🚀 End Print Report Modal 🚀 */}
    </Box>
  );
};

export default PriceListMaster;